import axios from 'axios';
import { protectedResourcesScopes } from '../../../../../auth/config';
import { acquireToken } from '../../../../../auth/msal';

const scope = protectedResourcesScopes.core;
const apiUrl = `https://meris-backend.ashyflower-93837a9b.brazilsouth.azurecontainerapps.io`;
// const apiUrl = `http://localhost:3333`;

export interface AssetProperty {
  key: string;
  label: string;
}

export interface AssetCategory {
  id: string;
  name: string;
  properties: AssetProperty[];
}

export interface InstrumentOption {
  label: string;
  value: string;
}


export interface TestField {
  type: 'select' | 'input';
  typeVariant: 'single' | 'multiple';
  isDisabled: boolean;
  isRequired: boolean;
  defaultValue: string | string[];
  validValue: string | string[];
  label: string;
  options?: string[];
}

export interface TestSubStep {
  title: string;
  hints: string[];
  photo: string;
  instrumentIds?: string[];
  shouldValidate?: boolean;
}

export interface TestStep {
  title: string;
  stepType: 'form' | 'camera' | 'table';
  isRequired: boolean;
  isHidden?: boolean;
  durationInSeconds?: number;
  intervalInSeconds?: number;
  fields?: TestField[];
  subSteps?: TestSubStep[];
  rowLabel?: string;
  rows?: string[];
  columns?: string[];
}

export interface CreateTestRequest {
  title: string;
  reportName: string;
  code: string;
  platform: 'mobile' | 'desktop';
  allowedAttempts: number;
  assetCategories: string[];
  instrumentIds: string[];
  annotations: string[];
  assetDisplayProperties: string[];
  steps: TestStep[];
}
export interface CommissioningTest extends CreateTestRequest {
  id: string;
  createdAt?: string;
  updatedAt?: string;
}

export async function getTests(instance: any): Promise<CommissioningTest[]> {
  try {
    const accessToken = await acquireToken(instance, scope);
    const { data } = await axios.get(`${apiUrl}/commissioning-test`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    return data;
  } catch (error) {
    throw error;
  }
}

export async function getAllCategories(instance: any): Promise<AssetCategory[]> {
  try {
    const accessToken = await acquireToken(instance, scope);
    const { data } = await axios.get(`${apiUrl}/asset-category`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    return data;
  } catch (error) {
    throw error;
  }
}

export async function createTest(instance: any, test: CreateTestRequest): Promise<CommissioningTest> {
  try {
    const accessToken = await acquireToken(instance, scope);
    const { data } = await axios.post(`${apiUrl}/commissioning-test`, test, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    return data;
  } catch (error) {
    throw error;
  }
}

export async function getTestById(instance: any, testId: string): Promise<CommissioningTest> {
  try {
    const accessToken = await acquireToken(instance, scope);
    const { data } = await axios.get(`${apiUrl}/commissioning-test/${testId}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    // Normalizar o ID caso venha em formato diferente
    if (data && !data.id) {
      data.id = data._id?.$oid || data._id || testId;
    }

    return data;
  } catch (error) {
    throw error;
  }
}

export async function updateTest(instance: any, testId: string, test: CreateTestRequest): Promise<CommissioningTest> {
  try {
    const accessToken = await acquireToken(instance, scope);
    const { data } = await axios.put(`${apiUrl}/commissioning-test/${testId}`, test, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    return data;
  } catch (error) {
    throw error;
  }
}

export async function getInstrumentOptions(instance: any): Promise<InstrumentOption[]> {
  try {
    const accessToken = await acquireToken(instance, scope);
    const { data } = await axios.get(`${apiUrl}/instruments-category/options/categories`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    return data;
  } catch (error) {
    throw error;
  }
}


